import React, { useEffect } from 'react'

export default function OfficeMode() {
  useEffect(() => {
    if (localStorage.getItem("office") != null) {
      if (localStorage.getItem("office") == "true") {
        localStorage.setItem("office", "false");
      } else {
        localStorage.setItem("office", "true");
      }
    } else {
      localStorage.setItem("office", "true");
      
    }
    setTimeout(() => {
      window.location = "/";
    }, 230);
  }, [])
  
  return (
    <div>OfficeMode</div>
  )
}
